import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from '@mui/material'
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import SaveIcon from '@mui/icons-material/Save';

import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { fetchEfectuarVotoCriterios } from '../../../redux/Encuestas/EncuestasSlice';

import swal from 'sweetalert';

export const VotacionCriteriosCard = ({ open : { open, empleado }, setOpen }) => {

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-FORM
    const { 
        control, 
        handleSubmit, 
        reset, 
        setValue,
        formState: { errors }
    } = useFormContext();

    // ? HOOK-WATCH
    const criteriosEmpleado = useWatch({
        control, 
        name: 'criteriosEmpleado'
    });

    const onSubmit = ({ criteriosEmpleado }) => {

        var validacionSeleccionUnSiCriterio = criteriosEmpleado.some(x => x.aplica);

        if(!validacionSeleccionUnSiCriterio){
            swal("Adverencia", "Debe seleccionar al menos un criterio.", "warning");
            return;
        }

        dispatch(fetchEfectuarVotoCriterios(criteriosEmpleado))
    }

  return (
    <Dialog
    PaperProps={{ sx: { width: "55%", height: '55%' } }}
    open={open}
    maxWidth='lg'
    >

        <DialogTitle sx={{textTransform: 'uppercase'}} className='text-mem text-center'> Votar por: {empleado.nombres} {empleado.apellidos}</DialogTitle>
        <Divider />

        <DialogContent>
            <Typography mt={1} fontSize={18}>Criterios a Evaluar:</Typography>
            <Divider />
            <form id='formCriterios' onSubmit={handleSubmit(onSubmit)}>
                <div className='mt-3'>
                    {
                        criteriosEmpleado.map((item, index) => (
                            <div key={index}>
                                <div className='row mt-1'>
                                    <div className='col-8'>
                                        <Typography>{item.descripcion}</Typography>
                                    </div>
                                    <div className='col-4'>
                                        <Controller
                                        name={`criteriosEmpleado.${index}.aplica`}
                                        control={control}
                                        rules={{
                                            validate: value =>
                                                value !== null || "Este campo es requerido"
                                        }}
                                        render={({ field }) => (
                                        <div
                                            className="btn-group"
                                            role="group"
                                            aria-label="Basic outlined example"
                                        >
                                            <button
                                            value={true}
                                            type="button"
                                            className={`btn ${
                                                field.value
                                                ? "btn-primary-mem"
                                                : "btn-outline-primary-mem"
                                            } me-2`}
                                            onClick={() => {
                                                // 1) Poner todos los demás en false
                                                criteriosEmpleado.forEach((c, i) => {
                                                    if (c.criterioId !== item.criterioId) {
                                                        setValue(`criteriosEmpleado.${i}.aplica`, false, {
                                                            shouldDirty: true,
                                                            shouldTouch: true,
                                                            shouldValidate: true,
                                                        })
                                                    }
                                                })

                                                // 2) Este en true
                                                field.onChange(true)
                                            }}
                                            >
                                            Si
                                            </button>

                                            <button
                                            value={false}
                                            type="button"
                                            className={`btn ${
                                                field.value === null || field.value
                                                ? "btn-outline-primary-mem"
                                                : "btn-primary-mem"
                                            }`}
                                            onClick={() => field.onChange(false)}
                                            >
                                            No
                                            </button>
                                        </div>
                                        )}
                                    />

                                    </div>
                                </div>

                                <p
                                className="text-danger"
                                hidden={!errors?.criteriosEmpleado?.[index]?.aplica?.message}
                                >
                                    {errors?.criteriosEmpleado?.[index]?.aplica?.message}
                                </p>

                            </div>
                        ))
                    }
                </div>
            </form>

        </DialogContent>
        
        <Divider />
        <DialogActions className='justify-content-center'>
            <button 
            id='btn-cancelar' 
            type='button' 
            onClick={() => { 
                    setOpen({ open: false, empleado: {}});
                    reset();
                }
            } 
            className='btn btn-danger'
            >
            <DoNotDisturbAltIcon sx={{marginTop: -0.5, marginRight: 0.5}}/>CANCELAR
            </button>

            <button type='submit' form='formCriterios' id='btn-guardar' className='btn btn-primary-mem'><SaveIcon sx={{marginTop: -0.5, marginRight: 0.5}}/>GUARDAR</button>
        </DialogActions>

    </Dialog>
  )
}
